import { BookingProcessStore } from "./types";

export const defaultState: BookingProcessStore = {
  isBooked: false,
  isBooking: false,
  selectedServices: [],
  emptyFields: [],
};
